/**
 * Function that calculates post index depending on the current page
 *
 * @param index - index at which post is found - index always will be a number between 0 and postsPerPage
 * @param currentPage - current page on which post is displayed
 * @param postsPerPage - Posts per page defined at root
 * @returns number
 */
export const calculatePaginatedPostIndex = (
  index: number,
  currentPage: number,
  postsPerPage: number
): number => {
  if (currentPage === 1) {
    return index + 1;
  }
  return currentPage * postsPerPage - postsPerPage + index + 1;
};
